// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import Audit from "@material-ui/icons/TrackChanges";
import AirlineRouteIcon from "@material-ui/icons/Flight";
import Landing from "@material-ui/icons/FlightLandOutlined";

import MainLandingPage from "../layouts/Landing/RegionalLanding/landing";

import DashboardPage from "Regional-Views/Dashboard/Dashboard.jsx";
import ExchangeRateAirlineView from "Regional-Views/ExchangeRateAirline/airlineView.js";
import NotFound from "Regional-Views/NotFound/Index.jsx";
import HelpCenter from "../Regional-Views/HelpCenter/index"
import HelpIcon from "@material-ui/icons/HelpOutline"

const dashboardRoutes = [
  {
    path: "/main-landing",
    sidebarName: "Main Landing",
    navbarName: "Main Landing",
    icon: Landing,
    component: MainLandingPage,
    subMenu: [],
  },
  {
    path: "/app/psc-regional",
    sidebarName: "Dashboard",
    isNotVisible: true,
    navbarName: "Dashboard",
    icon: Dashboard,
    subMenu: [],
    component: DashboardPage
  },
  {
    path: "/app/psc-regional/dashboard",
    sidebarName: "Dashboard",
    isNotVisible: true,
    navbarName: "Dashboard",
    icon: Dashboard,
    subMenu: [],
    component: DashboardPage
  },
  {
    path: "/app/psc-regional/exchange-rate",
    sidebarName: "Exchange Rate",
    navbarName: "Exchange Rate",
    icon: AirlineRouteIcon,
    subMenu: [],
    component: ExchangeRateAirlineView,
  },
  {
    path: "/app/psc-regional/help-center",
    sidebarName: "Help Center",
    navbarName: "Help Center",
    icon: HelpIcon,
    component: HelpCenter,
    subMenu: []
  },
  {
    isNotVisible: true,
    path: "**",
    sidebarName: "Not found",
    navbarName: "Not Found",
    icon: Audit,
    subMenu: [],
    component: NotFound,
    
  }
];

export default dashboardRoutes;



// WEBPACK FOOTER //
// ./src/routes/regional-executive.jsx